import Spinner from "@/components/Spinner";
import clsx from "clsx";
import Link from "next/link";
import React from "react";
import { ArrowRight } from "react-feather";

const RoundedButton = ({
  onClick = () => null,
  children = "",
  type = "button",
  disabled = false,
  fullWidth = false,
  centered = false,
  icon = ArrowRight,
  isLoading = false,
  size = "base",
  href = "",
  target = "_self",
}) => {
  const Icon = icon;

  const Element = !!href ? Link : "button";

  return (
    <Element
      className={clsx(
        "RoundedButton",
        "inline-flex items-center justify-between space-x-3 whitespace-nowrap rounded-full leading-none transition",
        {
          "w-full lg:w-auto": !fullWidth,
          "bg-sky-500 text-white": !disabled,
          "bg-gray-300 text-gray-700": disabled,
          "w-full": fullWidth,
          "hover:-translate-y-0.5 hover:bg-sky-600": !disabled,
          "h-12 px-6 lg:pr-4": size === "base",
          "h-11 px-6 lg:pr-4": size === "sm",
          "mx-auto": centered,
        },
      )}
      type={type}
      onClick={onClick}
      disabled={disabled}
      href={href || undefined}
      target={href ? target : undefined}
    >
      <div
        className={clsx("font-medium", {
          "text-lg": size === "base",
          "text-base": size === "sm",
        })}
      >
        {children}
      </div>
      {!isLoading && (
        <div className={clsx("flex h-6 w-6 items-center")}>
          <Icon
            className={clsx("stroke-[1.5]", {
              "h-5 w-5": size === "base",
              "h-4 w-4": size === "sm",
            })}
          />
        </div>
      )}
      {isLoading && (
        <div className={clsx("flex h-6 w-6 items-center")}>
          <Spinner size="sm" />
        </div>
      )}
    </Element>
  );
};

export default RoundedButton;
